module.exports = __webpack_public_path__ + "img/share.b8d211be.svg";